import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { InlineNotificationComponent } from './inline-notification.component';

/**
 * A module containing objects associated with inline notifications
 */

export class InlineNotificationModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [
    InlineNotificationComponent
  ],
  exports: [
    InlineNotificationComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
